import styled from 'styled-components'

export const FormTitle = styled.div`
  margin-top: 51px;
  h1 {
    font-size: 22px;
  }
`

export const ChangeDataButtonArea = styled.div`
  position: absolute;
  right: 3vw;
`

export const NoArrowNumberInputArea = styled.div`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`
export const SectionTitle = styled.div`
  color: #888;
  font-size: 15px;
  font-weight: 400;
  margin-top: 1.0rem;
  margin-bottom: 0.5rem;
  position: relative;
  padding-bottom: 12px;
`
